module.exports = "<button [class]=\"classes\" [type]=\"type\" (click)=\"click()\">\r\n  <ng-content></ng-content>\r\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/analytics-button/analytics-button.component.html
// module id = ./src/app/shared/components/analytics-button/analytics-button.component.html
// module chunks = main